import Cookies from 'js-cookie';
import { Redirect } from 'react-router-dom';

import COOKIES_KEY from 'constants/cookies';

const token = Cookies.get(COOKIES_KEY.TOKEN);

const NewApplicationGuard = (
  OriginalComponent: <T = unknown>(...args: T[]) => JSX.Element,
) => {
  const MixedComponent = () => {
    if (!token) return <Redirect to='/login?next=/application' />;

    return <OriginalComponent />;
  };

  return MixedComponent;
};

export default NewApplicationGuard;
